'use strict';
/*global _gaq:false */
/*global _fbq:false */

app.config(function ($analyticsProvider) {
  //disable automatic pageview tracking
  $analyticsProvider.virtualPageviews(false);
});

var facebookTrackingInitialized = false;
app.service('rmAnalytics', function ($rootScope, $log, $analytics, $timeout) {
  this.setInstance = function (instance) {
    if (!instance) {
      return console.warn('No valid instance passed to init analytics variables');
    }
    _gaq.push(['_setCustomVar',
      1,                   // This custom var is set to slot #1.  Required parameter.
      'instanceId',        // The name acts as a kind of category for the user activity.  Required parameter.
      instance._id, // This value of the custom variable.  Required parameter.
      2                    // Sets the scope to session-level.  Optional parameter.
    ]);
    _gaq.push(['_setAccount', instance.analyticsProfileID]);

    var fbPixelId = _.get(instance, 'analytics.fbPixelId');
    if (fbPixelId && !facebookTrackingInitialized) {
      _fbq.push(['addPixelId', fbPixelId]);
      _fbq.push(['track', 'PixelInitialized', {}]);
      facebookTrackingInitialized = true;
    }
  };
  this.setUser = function (user) {
    if (!user || !user._id) {
      _gaq.push(['_deleteCustomVar', 2]);
    } else {
      _gaq.push(['_setCustomVar',
        2,                   // This custom var is set to slot #1.  Required parameter.
        'userId',            // The name acts as a kind of category for the user activity.  Required parameter.
        user._id, // This value of the custom variable.  Required parameter.
        2                    // Sets the scope to session-level.  Optional parameter.
      ]);
    }
  };

  this.track = function (event) {
    switch (event) {
      case 'signup':
        if (_.get($rootScope, 'instance.slug') === 'learn') {
          //fbq('track', 'Lead');
          //fbq('track', 'ViewContent');
          window._fbq.push(['track', 'Lead']);
          window._fbq.push(['track', 'ViewContent']);
        }
        break;
    }
  };

  this.init = function () {
    $rootScope.$watch('user', this.setUser);
    $rootScope.$watch('instance', this.setInstance);

    $rootScope.$on('$stateChangeSuccess', function () {
      $timeout($analytics.pageTrack);
    });
  };
});

app.run(function (rmAnalytics) {
  rmAnalytics.init();
});
